import axios from "axios";

/*let siteUrl = 'http://polifarb-color-back';*/
let siteUrl = 'http://api.color.polifarb.ua';

const URL_LOGIN = siteUrl+'/api/login';
const URL_REQ = siteUrl+'/api/register';
const URL_LOGOUT = siteUrl+'/api/logout';
const URL_RESET_PASSWORD = siteUrl+'/api/reset-password';
const URL_PASSWORD_EMAIL= siteUrl+'/api/forgot-password';


// initial state
const state = () => ({
    user: null,
    status: '',
})

// getters
const getters = {

    authStatus: state => state.status,
}

// actions
const actions = {
    login({commit}, user){
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: URL_LOGIN, data: user, method: 'POST' })
                .then(resp => {
                    localStorage.setItem('token', resp.data.token)
                    localStorage.setItem('role', resp.data.role)
                    commit('auth_success')
                    resolve(resp)
                })
                .catch(err => {
                    commit('auth_error')
                    localStorage.removeItem('token')
                    localStorage.removeItem('role')
                    reject(err.response.data)
                })
        })
    },
    register({commit}, user){
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: URL_REQ, data: user, method: 'POST' })
                .then(resp => {
                    /*localStorage.setItem('token', resp.data)
                    axios.defaults.headers.common['Authorization'] = resp.data.token
                    commit('auth_success', resp.data.token)*/
                    resolve(resp.data)
                })
                .catch(err => {
                    commit('auth_error')
                    /*localStorage.removeItem('token')*/
                    reject(err.response.data)
                })
        })
    },
    logout({commit}){
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: URL_LOGOUT, method: 'GET' })
                .then(resp => {
                    localStorage.removeItem('token')
                    localStorage.removeItem('role')
                    commit('auth_logout')
                    resolve(resp.data)
                })
                .catch(err => {
                    localStorage.removeItem('token')
                    localStorage.removeItem('role')
                    commit('auth_error')
                    reject(err.response.data)
                    location.replace("/");
                })
        })
    },
    reset_password({commit}, user){
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: URL_RESET_PASSWORD, data: user, method: 'POST' })
                .then(resp => {
                    resolve(resp.data)
                })
                .catch(err => {
                    commit('auth_error')
                    reject(err.response.data)
                })
        })
    },
    restore_password({commit}, user){
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: URL_PASSWORD_EMAIL, data: user, method: 'POST' })
                .then(resp => {
                    resolve(resp.data)
                })
                .catch(err => {
                    commit('auth_error')

                    reject(err.response.data)
                })
        })
    },
}

// mutations
const mutations = {
    auth_request(state){
        state.status = 'loading'
    },
    auth_success(state){
        state.status = 'success'
    },
    auth_error(state){
        state.status = 'error'
    },
    auth_logout(state){
        state.status = ''
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}